import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import FundingHeader from "./FundingHeader";
import FundingDetailsTab from "./FundingDetailsTab";

function FundingWrap() {

    return (
        <>
            <div className="package-details-wrapper pt-110">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="tour-package-details">
                                <FundingHeader />
                                <FundingDetailsTab />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="package-sidebar">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FundingWrap;
